module.exports = __webpack_public_path__ + "static/media/logoEgshop.82008efc.svg";